export const logApiCall = (method: string, url: string, body?: unknown): void => {
  if (process.env.NODE_ENV === "test") return;

  console.groupCollapsed(`%c${method} %c${url}`, "color:#0b5cab;font-weight:bold", "color:inherit");
  if (body !== undefined) console.log(body);
  console.groupEnd();
};
